import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { numberNanable } from "commons/ultilities/validation";
import { IAddMaterial } from "mobx-stores/_models/material-inventory/material";
import { string } from "yup";

export const getAddMaterialSchema = (): ObjectSchemaType<IAddMaterial> => ({
  code: {
    type: InputType.text,
    gridSize: 12,
    label: "Bộ phận/Khâu SX",
    validattionYupSchema: string().trim().required().max(50),
  },
  type: {
    type: InputType.text,
    gridSize: 12,
    label: "Loại Hàng",
    validattionYupSchema: string().trim().required().max(50),
  },
  name: {
    type: InputType.text,
    gridSize: 12,
    label: "Tên Hàng (Mã Hàng)",
    validattionYupSchema: string().trim().required().max(255),
  },
  barcode: {
    type: InputType.text,
    gridSize: 12,
    label: "Mã barcode",
    validattionYupSchema: string().trim().max(255),
  },

  specificationSize: {
    type: InputType.number,
    gridSize: 4,
    label: "Dài (Ngang)",
    validattionYupSchema: numberNanable(),
  },
  specificationLength: {
    type: InputType.number,
    gridSize: 4,
    label: "Rộng (Dọc)",
    validattionYupSchema: numberNanable(),
  },
  specificationThick: {
    type: InputType.number,
    gridSize: 4,
    label: "Cao (Dày)",
    validattionYupSchema: numberNanable(),
  },
  allowedInventory: {
    type: InputType.text,
    gridSize: 12,
    label: "Tồn Kho Cho Phép",
    validattionYupSchema: string().trim().max(255),
  },
});
